import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Link, Menu, MenuItem } from '@mui/material';
import { GridColDef, GridRenderCellParams, GridRowModel, GridValueFormatterParams } from '@mui/x-data-grid-pro';
import moment from 'moment';
import config from 'src/data/config';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { usePermissionWrapper } from '../common/hooks/usePermissionWrapper';
import { getPoratlHost } from '../common/hooks/useUtils';

export interface IColumnProps {
  anchorEl: null | HTMLElement;
  onGridLinkClick: (row: GridRowModel) => void;
  gethashedurikey: (params: GridValueFormatterParams<any>) => void;
  handleClick: (e: React.MouseEvent<HTMLElement>, row: GridRowModel) => void;
  handleClose: (optionMenuItem: { id: string; name: string; isEnabled: boolean }) => void;
  artifactList: string[];
}
export const useColumns = (props: IColumnProps) => {
  const { anchorEl, onGridLinkClick, gethashedurikey, handleClick, handleClose, artifactList } = props;
  const open = Boolean(anchorEl);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const optionsMenu = config.tmfBinderViewer?.optionsMenu;
  const { checkPermission, checkPermissionDocViewLevel } = usePermissionWrapper();
  const appName = 'ETMF';
  const columns: GridColDef[] = [
    {
      field: 'tmf_document_name',
      headerName: 'Document Name',
      width: 250,
      valueFormatter: params =>
        `=HYPERLINK("${getPoratlHost()}/?application=${appName}&key=${gethashedurikey(params)}", "${params.value}")`,
      renderCell: (params: any) =>
        checkPermission('view_document_details') ? (
          <Link onClick={() => onGridLinkClick(params.row)}>{params.value!.toString()}</Link>
        ) : (
          params.value!.toString()
        )
    },
    {
      field: 'tmf_artifact_name',
      headerName: 'Artifact Name',
      width: 200,
      type: 'singleSelect',
      valueOptions: artifactList
    },
    {
      field: 'tmf_doc_level',
      headerName: 'TMF Level',
      width: 100,
      type: 'singleSelect',
      valueOptions: ['Study', 'Country', 'Site']
    },
    { field: 'tmf_doc_study', headerName: 'Study', width: 150 },
    { field: 'tmf_doc_country', headerName: 'Country', width: 100 },
    { field: 'tmf_doc_site', headerName: 'Site', width: 150 },
    {
      field: 'tmf_doc_version_number',
      headerName: 'Version (latest version)',
      width: 100,
      type: 'number',
      align: 'left'
    },
    {
      field: 'tmf_doc_viewer_req_certified_copy',
      headerName: 'Certified Copy (Yes/No)',
      width: 100,
      type: 'singleSelect',
      valueOptions: ['Y', 'N']
    },
    {
      field: 'created_on',
      headerName: 'Created on',
      width: 150,
      type: 'date',
      valueGetter: params => {
        if (params.value !== null) {
          return moment(new Date(params.value)).format(userPreferedDateFormat.toUpperCase());
        }
        return;
      }
    },
    {
      field: 'tmf_doc_status',
      headerName: 'Status ',
      width: 160,
      type: 'singleSelect',
      valueOptions: ['Uploaded', 'Ready for approval', 'Approved', 'Rejected']
    },
    {
      field: 'Actions',
      type: 'actions',
      width: 20,
      hideable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <IconButton
              aria-label="more"
              id={params?.row?.fileId}
              aria-controls={open ? 'action-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={(e: any) => handleClick(e, params.row)}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="action-menu"
              MenuListProps={{
                'aria-labelledby': 'moreAction-button'
              }}
              anchorEl={anchorEl}
              open={params?.row?.fileId === anchorEl?.id}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              className="listmenu-3dots"
            >
              {optionsMenu?.map((optionMenuItem, index) => {
                if (optionMenuItem.id === 'sendAsLink') {
                  if (optionMenuItem.isEnabled) {
                    return (
                      <MenuItem key={index} onClick={() => handleClose(optionMenuItem)} disableRipple>
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  }
                } else if (optionMenuItem.id === 'auditTrail') {
                  if (optionMenuItem.isEnabled) {
                    return (
                      <MenuItem key={index} onClick={() => handleClose(optionMenuItem)} disableRipple>
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  }
                } else if (optionMenuItem.id === 'versionHistory') {
                  if (optionMenuItem.isEnabled) {
                    return (
                      <MenuItem key={index} onClick={() => handleClose(optionMenuItem)} disableRipple>
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  }
                } else if (optionMenuItem.id === 'addNewVersion') {
                  return (
                    <MenuItem key={index} onClick={() => handleClose(optionMenuItem)} disableRipple>
                      {optionMenuItem.name}
                    </MenuItem>
                  );
                } else if (optionMenuItem.isEnabled) {
                  return (
                    <MenuItem key={index} onClick={() => handleClose(optionMenuItem)} disableRipple>
                      {optionMenuItem.name}
                    </MenuItem>
                  );
                }
              })}
            </Menu>
          </div>
        );
      }
    }
  ];

  return { columns };
};
